document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // Cart drawer
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartCloser = document.querySelector('.cart-drawer__close');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  cartOpeners.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  if (cartCloser) cartCloser.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function refreshCartDrawer() {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          body.innerHTML = '<p>Your cart is empty.</p>';
          return;
        }
        var html = '<ul style="list-style:none;padding:0;margin:0;">';
        cart.items.forEach(function (item) {
          html += '<li style="display:flex;gap:12px;margin-bottom:16px;">' +
            '<img src="' + item.image + '" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:4px;">' +
            '<div><div style="font-size:14px;">' + item.product_title + '</div>' +
            '<div style="font-size:13px;color:#6b6b5f;">Qty ' + item.quantity + ' &middot; ' + (item.final_line_price / 100).toFixed(2) + '</div></div>' +
            '</li>';
        });
        html += '</ul>';
        html += '<a class="btn" href="/cart" style="width:100%;justify-content:center;margin-top:10px;">View Cart</a>';
        body.innerHTML = html;
      });
  }

  // Add-to-cart forms (product card quick add, if present)
  document.querySelectorAll('form[data-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { openCart(); })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });
});
